export default __webpack_public_path__ + "static/media/platinum suites2.9045a5bb.jpeg";